export function loadGoogleApi() {
	return new Promise((resolve, reject) => {
		// Check if script is already in the DOM
		if (document.getElementById("google-api-script")) {
			// If the script is already added, we can try resolving immediately.
			// But if you need to re-initialize or configure again, you can do so here.
			return resolve(window.gapi);
		}

		const script = document.createElement("script");
		script.src = "/assets/js/api.js";
		script.id = "google-api-script";
		script.async = true;
		script.defer = true;

		script.onload = () => {
			// The google script has loaded, now load the client
			window.gapi.load("client", async () => {
				try {
					// For example, you could initialize the client with extra config here:
					// await window.gapi.client.init({
					//   apiKey: '<YOUR_API_KEY>',
					//   // ...other config
					// });
					resolve(window.gapi);
				} catch (error) {
					reject(error);
				}
			});
		};

		script.onerror = () => {
			reject(new Error("Failed to load Google API script."));
		};

		document.body.appendChild(script);
	});
}
